export enum AboutYouInfoQuestionKey {
  DateOfBirth = "dateOfBirth",
  Sex = "sex",
  GenderIdentity = "genderIdentity",
  Address = "address",
  Partner = "partner",
  PartnerName = "partnerName",
  PartnerPreferredName = "partnerPreferredName",
  PartnerEmail = "partnerEmail",
  PartnerDateOfBirth = "partnerDateOfBirth",
  PartnerSex = "partnerSex",
  PartnerGenderIdentity = "partnerGenderIdentity"
}

export enum JourneyInfoQuestionKey {
  Journey = "journey",
  JourneyStage = "journeyStage",
  PocPrefSameBackground = "pocPrefSameBackground",
  SocialDeterminantsOfHealth = "socialDeterminantsOfHealth",
  MostHelpfulNow = "mostHelpfulNow",
  InterestNoIvf = "interestNoIvf",
  AgencyAttorneyName = "agencyAttorneyName",
  ClinicAgencyAttorneyName = "clinicAgencyAttorneyName",
  ClinicName = "clinicName",
  AdoptionInterest = "adoptionInterest",
  GestationalCarrierInMind = "gestationalCarrierInMind",
  GestationalCarrierDeliverLocation = "gestationalCarrierDeliverLocation",
  PreservationInterest = "preservationInterest",
  DoAnyApply = "doAnyApply",
  PartnerDoAnyApply = "partnerDoAnyApply",
  DueDate = "dueDate",
  DeliveryDate = "deliveryDate",
  NumberOfChildren = "numberOfChildren",
  IvfTreatmentStart = "ivfTreatmentStart",
  MedicationStartDate = "medicationStartDate",
  PreservationCycleTesting = "preservationCycleTesting",
  EggRetrievalDate = "eggRetrievalDate",
  AmabAfabMedicalPreference = "AmabAfabMedicalPreference",
  IsStillInPrevJourneyStage = "IsStillInPrevJourneyStage",
  GoalTimeframe = "goalTimeframe"
}

export enum AdditionalInfoQuestionKey {
  MemberJourneyAdditionalInfo = "memberJourneyAdditionalInfo",
  MedicalAdditionalInfo = "medicalAdditionalInfo"
}

export enum MedicalInfoQuestionKey {
  PregnancyMetWithObgyn = "pregnancyMetWithObgyn",
  PregnancyPastFertilityTreatment = "pregnancyPastFertilityTreatment",
  CyclesAreRegular = "cyclesAreRegular",
  CycleDetails = "cycleDetails",
  PeriodsPainful = "periodsPainful",
  PeriodsPainfulDetails = "periodsPainfulDetails",
  PregnantPreviously = "pregnantPreviously",
  PregnantPreviouslyDetails = "pregnantPreviouslyDetails",
  MedicalHistory = "medicalHistory",
  MenopauseDiagnosis = "menopauseDiagnosis",
  MenopauseDiagnosisDetails = "menopauseDiagnosisDetails",
  MenopauseSymptoms = "menopauseSymptoms",
  PelvicSurgeryDetails = "pelvicSurgeryDetails",
  Conditions = "conditions",
  FamilyConditions = "familyConditions",
  CurrentlyTaking = "currentlyTaking",
  SmokeDrink = "smokeDrink",
  ExperiencingSymptoms = "experiencingSymptoms",
  BiologicalChildren = "biologicalChildren",
  HeightWeight = "heightWeight",
  LowTestosteroneSymptoms = "lowTestosteroneSymptoms",
  MentalHealthScreener = "mentalHealthScreener",
  PregnancyBabyFeedingPlan = "pregnancyBabyFeedingPlan",
  PostpartumBabyFeedingStatus = "postpartumBabyFeedingStatus",
  PregnancyReturnToWorkPlan = "pregnancyReturnToWorkPlan",
  PostpartumReturnToWorkStatus = "postpartumReturnToWorkStatus",
  PregnancyRaceEthnicity = "pregnancyRaceEthnicity",
  PrePregnancyHeightWeight = "prePregnancyHeightWeight"
}

// Answers keys that are unique to a particular medical flow
export enum MedicalInfoAnswerKey {
  PregnancyMetWithObgyn = "pregnancyMetWithObgyn",
  PregnancyPastFertilityTreatment = "pregnancyPastFertilityTreatment",
  CyclesAreRegular = "cyclesAreRegular",
  CycleDetails = "cycleDetails",
  PeriodsPainful = "periodsPainful",
  PeriodsPainfulDetails = "periodsPainfulDetails",
  PregnantPreviously = "pregnantPreviously",
  PregnantPreviouslyDetails = "pregnantPreviouslyDetails",
  FemaleMedicalHistory = "femaleMedicalHistory",
  MaleMedicalHistory = "maleMedicalHistory",
  MenopauseDiagnosis = "menopauseDiagnosis",
  MenopauseDiagnosisDetails = "menopauseDiagnosisDetails",
  MenopauseSymptoms = "menopauseSymptoms",
  PelvicSurgeryDetails = "pelvicSurgeryDetails",
  FemaleConditions = "femaleConditions",
  MaleConditions = "maleConditions",
  FemaleFamilyConditions = "femaleFamilyConditions",
  MaleFamilyConditions = "maleFamilyConditions",
  FemaleCurrentlyTaking = "femaleCurrentlyTaking",
  MaleCurrentlyTaking = "maleCurrentlyTaking",
  FemaleExperiencingSymptoms = "femaleExperiencingSymptoms",
  MaleExperiencingSymptoms = "femaleExperiencingSymptoms",
  BiologicalChildren = "biologicalChildren",
  LowTestosteroneSymptoms = "lowTestosteroneSymptoms",
  PregnancyBabyFeedingPlan = "pregnancyBabyFeedingPlan",
  PostpartumBabyFeedingStatus = "postpartumBabyFeedingStatus",
  PregnancyReturnToWorkPlan = "pregnancyReturnToWorkPlan",
  PostpartumReturnToWorkStatus = "postpartumReturnToWorkStatus",
  PregnancyRaceEthnicity = "pregnancyRaceEthnicity"
}
